import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AddCandidatesFromJobBoardsComponent } from './add-candidates-from-job-boards.component';
import { JobBoardsSupportedParametersModule } from './job-boards-supported-parameters/job-boards-supported-parameters.module';

@NgModule({
  declarations: [AddCandidatesFromJobBoardsComponent],
  imports: [
    CommonModule,
    TooltipModule.forRoot(),
    JobBoardsSupportedParametersModule
  ],
  exports: [AddCandidatesFromJobBoardsComponent],
  entryComponents: [AddCandidatesFromJobBoardsComponent]
})
export class AddCandidatesFromJobBoardsModule { }
